import { Box, Typography, Button } from "@mui/material";
import { Lock } from "lucide-react";
import { SecretStub } from "protogen/secrets_pb";
import { getSecretLabel } from "./Constants";
import useIsMobile from "../hooks/useIsMobile";
import { AccountStub } from "protogen/common_pb";

const SecretListItem = ({
  secret,
  creators,
  onClick,
}: {
  secret: SecretStub;
  creators: AccountStub[];
  onClick: (secret: SecretStub) => void;
}) => {
  const isMobile = useIsMobile();

  const creator = creators.find((c) => c.ref === secret.creatorRef);
  const creatorName = creator?.displayName || "";

  return (
    <Box
      sx={(theme) => ({
        width: "100%",
        display: "flex",
        borderRadius: "8px",
        padding: "16px 24px",
        border: `1px solid ${theme.palette.border}`,
      })}
    >
      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
        <Typography variant="body">{secret.name}</Typography>
        <Typography
          variant="bodySmall"
          sx={(theme) => ({ color: `${theme.palette.text.secondary}` })}
        >
          {/* Don't show "Other" */}
          {secret.valueType !== "secret" && (
            <>
              {getSecretLabel(secret.valueType)}
              {" • "}
            </>
          )}
          {creatorName}
        </Typography>
      </Box>
      <Box>
        <Button
          onClick={() => onClick(secret)}
          variant="text"
          startIcon={isMobile ? null : <Lock size={20} stroke="#8E9598"></Lock>}
        >
          Unlock
        </Button>
      </Box>
    </Box>
  );
};

export default ({
  secrets,
  creators,
  onClick,
  emptyMessage = "No secrets have been added yet.",
}: {
  secrets: SecretStub[];
  creators: any[];
  onClick: (secret: SecretStub) => void;
  emptyMessage?: string;
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: "16px",
        alignSelf: "stretch",
        flexDirection: "column",
        width: "100%",
      }}
    >
      {secrets.length === 0 && (
        <Typography variant="body1">{emptyMessage}</Typography>
      )}
      {secrets.map((secret) => {
        return (
          <SecretListItem
            key={secret.ref}
            secret={secret}
            creators={creators}
            onClick={onClick}
          />
        );
      })}
    </Box>
  );
};
